import { IForm } from '@/components/types'
import { useSearchDateShortcut } from '@/hooks/useSearch'
const shortcuts = useSearchDateShortcut()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'consumerName',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'lectureNum',
      type: 'select',
      label: '听课次数',
      placeholder: '请选择听课次数',
      options: [
        { title: '全部', value: '' },
        { title: '≥1', value: 1 },
        { title: '≥2', value: 2 },
        { title: '≥3', value: 3 },
        { title: '≥4', value: 4 },
        { title: '≥5', value: 5 },
        { title: '≥6', value: 6 },
        { title: '≥7', value: 7 },
        { title: '≥8', value: 8 },
        { title: '≥9', value: 9 },
        { title: '≥10', value: 10 }
      ]
    },
    {
      field: 'callNum',
      type: 'select',
      label: '通话次数',
      placeholder: '请选择通话次数',
      options: [
        { title: '全部', value: '' },
        { title: '≥1', value: 1 },
        { title: '≥2', value: 2 },
        { title: '≥3', value: 3 },
        { title: '≥4', value: 4 },
        { title: '≥5', value: 5 },
        { title: '≥6', value: 6 },
        { title: '≥7', value: 7 },
        { title: '≥8', value: 8 },
        { title: '≥9', value: 9 },
        { title: '≥10', value: 10 }
      ]
    },
    {
      field: 'updatedTime',
      type: 'datepicker',
      label: '访问时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        },
        shortcuts: shortcuts
      }
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    }
  ]
}
